var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    { on: { command: _vm.handleClick } },
    [
      _vm._t("dropdown-trigger"),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _vm.modeDropdown === "List"
            ? _c(
                "div",
                _vm._l(_vm.opcoesDropdown, function(option, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: option.visible !== false,
                          expression: "option.visible !== false"
                        }
                      ],
                      key: index,
                      attrs: {
                        command: option,
                        disabled: option.disabled,
                        divided: option.divided,
                        icon: option.icon
                      }
                    },
                    [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]
                  )
                }),
                1
              )
            : _c("div", [_vm._t("custom-content")], 2)
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11498b58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11498b58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Dropdowns/BaseDropdown/BaseDropdown.vue
// module id = null
// module chunks = 